webpackJsonp([235622271963294],{

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	__webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/bhavna_thakur.jpg";
	
	var icon2 = "https://winpeforum.com/assets/elements/Ganesh_Mani.jfif";
	var icon3 = "https://winpeforum.com/assets/elements/Sakshi_Chopra.jpg  ";
	var icon4 = "https://winpeforum.com/assets/elements/Naik_Sandeep.jpg";
	var icon5 = "https://winpeforum.com/assets/elements/sridhar-sankararaman-it.png";
	var icon6 = "https://winpeforum.com/assets/elements/Sawheny_Viraj.jpg";
	
	var icon7 = "https://winpeforum.com/assets/elements/Session1_Shikha_Pareek.jpg";
	var icon8 = "https://winpeforum.com/assets/elements/Pranay-Aggarwal.jpg";
	var icon9 = "https://winpeforum.com/assets/elements/shriya_bahul.jpeg";
	var icon16 = "https://winpeforum.com/assets/elements/Kanakvi.jpg";
	
	var icon10 = "https://winpeforum.com/assets/elements/Fernnades-Priyanka_Picture.jfif";
	var icon11 = "https://winpeforum.com/assets/elements/Isha-Dalal.JPG";
	var icon12 = "https://winpeforum.com/assets/elements/Anshul-Lodha.jpg";
	var icon13 = "https://winpeforum.com/assets/elements/Session2_Vishal.jfif";
	
	var icon14 = "https://winpeforum.com/assets/elements/Harjot-Dhaliwal.jpg";
	var icon15 = "https://winpeforum.com/assets/elements/VarunTalukdar.jpg";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var CareerBootcamp = function (_Component) {
	  _inherits(CareerBootcamp, _Component);
	
	  // constructor() {
	  //   super();
	  //   this.state = {
	  //     isShow: false,
	  //     activeItem: {},
	  //   };
	  // }
	
	  // togglePopUp = (item) => {
	  //   this.setState({
	  //     isShow: !this.state.isShow,
	  //     activeItem: item || {},
	  //   });
	  // };
	  function CareerBootcamp(args) {
	    _classCallCheck(this, CareerBootcamp);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.Speaker = [{
	      imgUrl: icon1,
	      desc: "<div>Bhavna Thakur joined Everstone as the Head of Capital Markets in 2015. She has\n        over 20 years of corporate finance, investment banking, M&amp;A and capital markets\n        experience and has worked with banks, financial services providers and legal firms\n        worldwide. These include investment banking at Citigroup Global Markets and\n        Morgan Stanley in Mumbai and Hong Kong respectively and capital markets and\n        M&amp;A law at Davis Polk &amp; Wardwell in New York and London and Paul Weiss in New\n        York. Bhavna holds a Bachelor of Laws from the National Law School of India\n        University, Bangalore and a Master of Laws from Columbia University, New York.\n\t\t</div>",
	      name: "Bhavna Thakur",
	      post: "<div>Managing Director, <br/>Capital Markets <br /> Everstone </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>Ganesh Mani is a Managing Director in Blackstone\u2019s Private Equity Group. Since joining Blackstone in\n        2011, Mr. Mani has been involved in Blackstone\u2019s investments in Sona Comstar, Aadhar Housing\n        Finance, Trans Maldivian Airways, IBS Software, International Tractors Limited, CMS Info Systems,\n        Multi Commodity Exchange of India Ltd., and Jagran Prakashan. Mr. Mani is involved in the\n        evaluation of investment opportunities in the pharma and healthcare, financial services, automotive,\n        and specialty chemicals sectors in South Asia. Mr. Mani currently serves on the Board of Directors of\n        Sona Comstar.\n        <br><br>\n        Before joining Blackstone, Mr. Mani was an Associate at the Boston Consulting Group. Mr. Mani\n        received a B.Tech. in Mechanical Engineering from the Indian Institute of Technology Bombay.\n\t\t\t\t</div>",
	      name: "Ganesh Mani",
	      post: "<div>Managing Director<br /> Blackstone</div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>Sakshi focuses on growth stage companies and has advised on investments across a range of Consumer, D2C and Fintech companies including Five-Star Business Finance, Indigo Paints, Wakefit, Faces, GoColors, Healthkart, Hector Beverages and B9 Beverages. \n\t\t\t\t<br />\n\t\t\t\t<br />\n\t\t\t\tSakshi began her career with Deutsche Bank, where she worked in the executive office of the Global Head of Private and Business Clients (Board Member of the Bank) in Germany, and later in Global Transaction Banking in India, before joining Sequoia Capital India in 2010. She holds an MBA from the Asian Institute of Management and a bachelor\u2019s degree from Sydenham College of Commerce.\n\t\t</div>",
	      name: "Sakshi Chopra",
	      post: "<div>Principal <br /> Sequoia India</div>"
	    }, {
	      imgUrl: icon4,
	      desc: "<div>Sandeep Naik is a Managing Director at General Atlantic and serves on the firms Executive\n        Committee. He head\u2019s the operations for India and Asia Pacific. Mr. Naik manages and oversees\n        all of GA\u2019s investments in these regions, which include Byju\u2019s, Jio, Reliance Retail,\n        Ruangguru, PT MAP Boga Adiperkasa (MBA), Krishna Institute of Medical Sciences Limited,\n        BillDesk, House of Anita Dongre, IIFL Wealth Management and KFin Technologies Private\n        Limited.\n        <br /><br />\n        Previously, Mr. Naik served as a partner and co\u2010head of the India office for Apax Partners, leading\n        their investments in healthcare, financial & business services and retail & consumer sectors. Prior\n        to joining Apax, he was a Global Marketing Manager at Medtronic Inc, a scientist at Mayo Clinic\n        and a Consultant with McKinsey. He is also the co\u2010founder of a medical device start up firm,\n        InfraScan Inc., which is focused on detecting bleeding inside the brain using a handheld device.\n        <br /><br />\n        Mr. Naik is an avid community worker. Among other philanthropic endeavors, he co\u2010founded\n        ToolBox India, an organization that brings professionals and non\u2010profits together to improve\n        productivity and efficiency within the social sector.\n        <br /><br />\n        Mr. Naik holds a BTech in Instrumentation Engineering from the University of Mumbai, an M.S.\n        in Biomedical Engineering from the Medical College of\n        Virginia and an M.B.A. in Finance from The Wharton School of Business, University of\n        Pennsylvania. Mr. Naik was selected as a Young Global Leader by the World Economic Forum\n        and served on the Global Agenda Council of \u2018New Order of Economic Thinking\u2019. Mr. Naik is also\n        a member on the Wharton Asia Board.\n\t\t</div>",
	      name: "Sandeep Naik",
	      post: "<div>Managing Director <br /> General Atlantic</div>"
	    }, {
	      imgUrl: icon5,
	      desc: "<div>I have two decades of experience in financial services (including 15 years in private equity). I have\n        been with <a href=\"https://multiplesequity.com/\" target=\"\n        _BLANK\" >Multiples</a> (US 1.5 bn PE fund) since its inception in 2009. Prior\n        to this, I was with SUN Capital in London and E&Y in Mumbai.</br>\n        My current role is to lead investments in digital, B2C and consumer technology sectors. Previously, I\n        led investments across healthcare, pharma and manufacturing sectors. I have actively contributed to\n        the creation of and institutionalisation of investment and people evaluation frameworks for Multiples.\n        During my investing career and as an active Board member, I have been able to influence business\n        strategy and people decisions. I think of my ability to influence as a key strength and I use it to bring\n        about positive change. I enjoy brainstorming ideas with Founders and derive immense satisfaction\n        when they derive value from these interactions as well.</br></br>\n        I am a Chartered Accountant by training and received my MBA from Indian School of Business (Dean\u2019s\n        List). Recognised among \u201840 under 40\u2019 by AIWMI in 2018.</br></br>\n        My professional success has been greatly shaped by my mother, who always made available the time\n        and resources for the right things in life and taught me the value of resource allocation. When I am\n        not working, I enjoy spending time with my family, particularly with my young son and daughter.\n\t\t</div>",
	      name: "Sridhar Sankararaman",
	      post: "<div>Managing Director <br /> Multiples</div>"
	    }, {
	      imgUrl: icon6,
	      desc: "<div>Viraj Sawhney, based in Mumbai, joined Warburg Pincus in 2005 and evaluates investment opportunities across TMT and Business Services. Sectors covered by him include logistics, telecom, technology services and BPO. Prior to joining Warburg Pincus, Mr. Sawhney was an Engagement Manager with McKinsey & Company where he spent five years serving clients across India, S.E. Asia and Australia. He is a Director of Encora Holdings Limited, Vivtera Holdings, Princeton Digital Group, Ecom Express, Rivigo and Stellar Value Chain Solutions. Mr. Sawhney holds a B.A. degree in Mathematics from St. Stephens College (Delhi University) and a post-graduate diploma in management from IIM Ahmedabad.\n\t\t</div>",
	      name: "Viraj Sawhney",
	      post: "<div>Managing Director, Mumbai <br /> Warburg Pincus</div>"
	    }];
	
	    _this.Speaker1 = [{
	      imgUrl: icon16,
	      desc: "<div>Kanakvi joined Sequoia India in 2021 as an investment analyst in the growth\n        team, where she is exploring her passion for technology and start-ups across\n        sectors.<br/>\n        Prior to this, she was a business analyst at McKinsey & Company for a year and\n        half. During this time, she worked primarily on strategy studies and due\n        diligences in Financial Services and CPG.<br/>\n        She holds a B.Tech in Electronics and Electrical Communication Engineering\n        with a Minor in Computer Science from IIT Kharagpur. Kanakvi co-founded the\n        Lean In circle in her college campus and continues to provide mentorship to\n        and collaborate with other women on advancement in their professional as\n        well as personal journeys. \n\t\t</div>",
	      name: "Kanakvi Aggarwal",
	      post: "<div>Investment Analyst<br/>Sequoia India</div>"
	    }, {
	      imgUrl: icon8,
	      desc: "<div>Pranay Agarwal joined Warburg Pincus in 2020 and is an Associate in the Investments Group. He spends majority of his time in Technology, Real Estate and Industrial sectors at Warburg. Prior to joining Warburg, Pranay was with Bain & Company for ~2 years where he worked on 10-15 commercial diligences across different industries. He has also worked with a non-profit \u2018Goonj\u2019 for brief period and was helping them scale their urban operations. He holds a B.Tech in Chemical Engineering and Minor in Management from Indian Institute of Technology, Bombay. Prior to that, he did his education from Pune and has interests in football and dancing\n\t\t</div>",
	      name: "Pranay Agarwal",
	      post: "<div>Associate<br/>Warburg Pincus </div>"
	    }, {
	      imgUrl: icon7,
	      desc: "<div>Shikha is an Investment Professional with the Credit and Special Situations team at KKR India. Previously, she was part of the India investment banking team at Bank of America and UBS respectively and has worked across sectors including consumer retail, health-care and technology. She is a Chartered Accountant by training",
	      name: "Shikha Pareek",
	      post: "<div>Investment Professional  <br /> KKR & Co. India</div>"
	    }, {
	      imgUrl: icon9,
	      desc: "<div>With a background in development economics and finance, Shriya has always been passionate about working in the impact space. Her current work entails focusing on investments that promote access to finance, clean and green energy and women owned businesses. She strongly believes that investing in women can have a multiplier effect on the economy by not only encouraging other younger women but also enabling investors to generate additional revenue streams. At Winpe she hopes to collaborate closely with Women Entrepreneurs to help them scale businesses and facilitate them in the fundraising processes.\n\t\t</div>",
	      name: "Shriya Bahul",
	      post: "<div>Investment Analyst <br />   IFC</div>"
	    }];
	    _this.Speaker2 = [{
	      imgUrl: icon12,
	      desc: "<div>Anshul joined the group in 2012 from Lazard where he worked as an investment banker focusing on M&A and private equity advisory practice across multiple sectors. Anshul started his career in the alternative investment division of ICICI (India\u2019s largest private sector bank) where he was part of private equity fund of fund\u2019s practice. He holds MBA from top Tier B School in India specializing in Finance and is a certified FRM (GARP).<br/><br/> Anshul currently leads the BFSI, Sales & Marketing, Legal and Property & Construction practices for PageGroup based out of the Mumbai office and has extensive experience recruiting for C-suite level positions in all of the above sectors.\n\t\t</div>",
	      name: "Anshul Lodha",
	      post: "<div>Regional Director<br/>Michael Page</div>"
	    }, {
	      imgUrl: icon11,
	      desc: "<div>I have spent six years in the investment team at Multiples, primarily in the\n        Consumer sector encompassing retail, food products, FMCG, consumer tech\n        and others. Apart from deal evaluation, I\u2019ve played a key role in developing the\n        firm\u2019s top-down thesis in these sectors and worked closely with portfolio\n        companies to create value.<br/>\n        My non-traditional background as a corporate law journalist with CNBC-TV18\n        enabled me to develop the art of building and nurturing relationships as well as\n        to identify impactful stories by asking the right questions. I enjoy leveraging\n        these skills in my role as an investment professional, driven by a curiosity for\n        businesses and what drives their success.<br/>\n        My education has presented me with an opportunity to be exposed to different\n        cultures. I hold a BA degree in English at Haverford College in PA, USA during\n        which time I spent a year at Oxford University in England. I received my MBA\n        from Columbia Business School in NYC.<br/>\n        I\u2019m an avid foodie and cook, and a fitness enthusiast. When not working, I enjoy\n        experimenting with new recipe and unwinding with my young son, who is my\n        greatest inspiration. </div>",
	      name: "Isha Dalal",
	      post: "<div>Vice President <br />Multiples</div>"
	    }, {
	      imgUrl: icon10,
	      desc: "<div>Priyanka Fernandes is the HR Business Partner in Blackstone\u2019s Human Resources Group. Since joining Blackstone in 2017, Ms. Fernandes has been involved in recruiting, developing and retaining talent for the India office.\n        <br/> <br/>\n        Before joining Blackstone, Ms. Fernandes was a part of the Human Resources team at Everstone Capital and Morgan Stanley. Ms. Fernandes received a B.Engg. in Computer Engineering from the University of Mumbai and a MSc in International Human Resources from the Manchester Metropolitan University.\n\t\t</div>",
	      name: "Priyanka Fernandes",
	      post: "<div>HR Business Partner <br />   Blackstone</div>"
	    }, {
	      imgUrl: icon13,
	      desc: "<div>Vishal is currently the Executive Director with the Everstone Group.\n<br/>\n        Previously worked as an Associate at Warburg Pincus since May 2012 to Apr 2017. Closed deals in auto ancillary space in April 2013, Real Estate deal in July 2015 and Oct 2015. Have worked extensively on Financial Services and Infrastructure space. Analyst with Asia Investment Banking team at J.P. Morgan covering Industrials & Transportation sector from 2010 to 2012 (Rated Best Analyst among my peer group). Gold Medalist at IIM Indore securing 1st Rank in both the years in a batch of 240, 2008-10. Awarded Best All-rounder at IIM Indore for outstanding performance in academic and extracurricular activities. Runners-up in the National round of the CFA Global Investment Challenge - an event organized by CFA Institute.\n\t\t</div>",
	      name: "Vishal Goenka",
	      post: "<div>Executive Director <br />   Everstone Group </div>"
	    }];
	
	    _this.Speaker3 = [{
	      imgUrl: icon14,
	      desc: "<div>Harjot focuses on investments in technology and telecom sectors and has participated in key deals including Fractal Analytics and Azentio Software. Prior to joining Apax Partners, Harjot was a Vice President at Warburg Pincus, where she focused on investment opportunities in TMT and business services sectors. Before pursuing her MBA, Harjot was a part of the investment team at TA Associates and the investment banking practice at Rothschild India. Harjot holds an MBA from Harvard Business School and a bachelor\u2019s degree in Chemical Engineering from Indian Institute of Technology Delhi.\n\t\t</div>",
	      name: "Harjot Dhaliwal",
	      post: "<div>Principal<br/>Apax Partners</div>"
	    }, {
	      imgUrl: icon15,
	      desc: "<div>Varun Talukdar is a Vice President at General Atlantic and focuses on the firm\u2019s investments in the India & Asia-Pacific region. Before joining General Atlantic in 2013, Varun was an Investment Professional at Premji Invest where he concentrated on investments in the retail & consumer and education sectors. Prior to that, Varun worked with the Lehman Brothers Bankruptcy Estate in New York to manage and unwind its Indian private and public equity assets. He has also worked at Bayside Capital, the Miami-based credit investment arm of H.I.G. Capital, and in the Industrials Investment Banking division of Bank of America in New York. </div>",
	      name: "Varun Talukdar",
	      post: "<div>Vice President <br />General Atlantic</div>"
	    }];
	    return _this;
	  }
	
	  CareerBootcamp.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  CareerBootcamp.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  CareerBootcamp.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe Ignite | Career Bootcamp      ",
	        image: "https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg",
	        description: "A series of three action-packed sessions that prepared participants for their break into investing. From getting your CV right to prepping for the interview and acing it.     ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "h1",
	            { className: "ignite-ask-me-anything__heading" },
	            "Winpe Ignite"
	          ),
	          _react2.default.createElement(
	            "h2",
	            { className: "ignite-ask-me-anything__heading" },
	            _react2.default.createElement(
	              "em",
	              null,
	              "Career Bootcamp"
	            )
	          ),
	          _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	          _react2.default.createElement(
	            "div",
	            { className: "ignite-ask-me-anything__date" },
	            _react2.default.createElement(
	              "span",
	              null,
	              "29 MAY, 5 JUNE, 12 JUNE 2021, 3-4pm IST, Online"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "ignite-ask-me-anything__intro" },
	            "A series of three action-packed sessions that prepared participants for their break into investing. From getting their CV right to prepping for the interview and acing it."
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "ignite-ask-me-anything__intro" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "SESSION 1:"
	            ),
	            " The Technical Q&A with recent hires into investing discussed how to track vacancies and apply, how to prepare, commonly asked questions; and some tips and tricks. At the end of the session, ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "20 attendees got to share their CVs with a panel of industry recruiters and received direct feedback on how to strengthen the same."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "ignite-ask-me-anything__intro" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "SESSION 2:"
	            ),
	            " A CV Review session with a panel of industry recruiters discussed how to make a CV stand out, what do recruiters look for, best practices, tips and some common mistakes. ",
	            _react2.default.createElement(
	              "a",
	              { href: "#IndustryLeaders" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "5 attendees got the opportunity to speak 1:1 with an industry leader."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "ignite-ask-me-anything__intro" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "SESSION 3:"
	            ),
	            " Acing the interview saw 2 amazing participants go through a mock interview with senior industry recruiters. The recruiters shared their tips on how to interview, what recruiters look for and how they evaluate candidates."
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "ignite-ask-me-anything__intro" },
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h2",
	            { className: "ignite-ask-me-anything__heading", style: { fontSize: '30px' } },
	            "Takeaways From the Sessions"
	          ),
	          _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	          _react2.default.createElement(
	            "a",
	            { href: "https://winpeforum.com/assets/elements/Panel-Discussion-With-Recent-Hires-On-Getting-That-Investing-Job.pdf", target: "_blank", style: { textDecoration: 'underline' } },
	            " ",
	            _react2.default.createElement(
	              "h2",
	              { className: "ignite-ask-me-anything__heading", style: { fontSize: '20px' } },
	              "Panel Discussion With Recent Hires On Getting That Investing Job"
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://winpeforum.com/assets/elements/Recruiters-Insights-On-How-To-Make-A-Good-CV.pdf", target: "_blank", style: { textDecoration: 'underline' } },
	            _react2.default.createElement(
	              "h2",
	              { className: "ignite-ask-me-anything__heading", style: { fontSize: '20px' } },
	              "Recruiters\u2019 Insights On How To Make A Good CV"
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://winpeforum.com/assets/elements/How-to-Ace-the-Interview.pdf", target: "_blank", style: { textDecoration: 'underline' } },
	            _react2.default.createElement(
	              "h2",
	              { className: "ignite-ask-me-anything__heading", style: { fontSize: '20px' } },
	              "How to Ace the Interview"
	            )
	          ),
	          " ",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h2",
	            { className: "ignite-ask-me-anything__heading", style: { fontSize: '30px' } },
	            "Testimonials"
	          ),
	          "  ",
	          _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "card col-md-12 mt-2" },
	              _react2.default.createElement(
	                "div",
	                { id: "carouselExampleControls", className: "carousel slide", "data-ride": "carousel", "data-interval": "100000" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "w-100 carousel-inner ", role: "listbox" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item active" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  " \u201CIncredibly insightful, many thanks!\u201D"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "-Shivani Kabra "
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item  " },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\u201Cthanks a lot. amazing bootcamp\u201D"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "-Shikha Gupta"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\u201CThis was a very insightful, valuable session - appreciate the panelists for taking out their time - and also for my CV review :) And big thanks to Winpe for hosting this :)\""
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "-Dhwani Nanavati"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\"thank you winPe for the lovely session\""
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "-Harini Shrinivasan"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\u201CThis was an amazing session! Hope we see more of impact investing sessions soon :)\u201D"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "- Shivangi Saxena"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\"Very authentic & great session!\""
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "- Vidisha Gupta"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\"Thank you for this incredibly insightful session!\""
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "- Moksha Miss"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\u201CThanks, very helpful!\u201D"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "- Anisha Belur"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\u201CThank you for the session!\u201D"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "- Shubhranka Mondal"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\u201CThank you Winpe team for the session!\u201D"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "- Heena Kedia"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "carousel-item" },
	                    _react2.default.createElement("div", { className: "bg" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "carousel-caption" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-12 col-12" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "ignite-ask-me-anything__intro" },
	                                _react2.default.createElement(
	                                  "em",
	                                  null,
	                                  "\u201CThank you for the session!\u201D"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "h2",
	                                { className: "ignite-ask-me-anything__intro" },
	                                "- Shubhranka Mondal"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "a",
	                  { className: "carousel-control-prev", href: "#carouselExampleControls", role: "button", "data-slide": "prev" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "carousel-control-prev-icon", "aria-hidden": "true" },
	                    " ",
	                    _react2.default.createElement("img", { style: { width: "10px" }, src: "https://winpeforum.com/assets/elements/left.png" })
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "sr-only" },
	                    "Previous"
	                  )
	                ),
	                _react2.default.createElement(
	                  "a",
	                  { className: "carousel-control-next", href: "#carouselExampleControls", role: "button", "data-slide": "next" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "carousel-control-next-icon", "aria-hidden": "true" },
	                    "  ",
	                    _react2.default.createElement("img", { style: { width: "10px" }, src: "https://winpeforum.com/assets/elements/right.png" }),
	                    "  "
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "sr-only" },
	                    "Next"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h2",
	            { className: "ignite-ask-me-anything__heading", style: { fontSize: '30px' } },
	            "Panelists"
	          ),
	          _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	          _react2.default.createElement(
	            "p",
	            { className: "ignite-ask-me-anything__intro" },
	            "Included representatives from Apax, Blackstone, Everstone, General Atlantic, IFC, KKR, Michael Page, Multiples, Warburg Pincus, Sequoia India."
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h4",
	            { className: "ignite-ask-me-anything__heading", id: "IndustryLeaders", style: { fontSize: '20px' } },
	            "Win a 1:1 chat with Industry Leaders"
	          ),
	          _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	          _react2.default.createElement(
	            "div",
	            { className: "Our_Speakers container" },
	            _react2.default.createElement(
	              "div",
	              { className: "Speakers_img" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                this.Speaker.map(function (item, i) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      className: "main_speaker_card col-md-2 col-sm-4 col-lg-2",
	                      key: i
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Scardd" },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "s_img",
	                          onClick: function onClick() {
	                            return _this3.togglePopUp(item);
	                          }
	                        },
	                        _react2.default.createElement("br", null),
	                        "  ",
	                        _react2.default.createElement(
	                          "center",
	                          null,
	                          "  ",
	                          _react2.default.createElement("img", {
	                            src: item.imgUrl,
	                            alt: item.name,
	                            className: "img-responsive",
	                            style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                          })
	                        )
	                      ),
	                      _react2.default.createElement("br", null),
	                      "    ",
	                      _react2.default.createElement("div", {
	                        className: "Speakers_name",
	                        dangerouslySetInnerHTML: { __html: item.name }
	                      }),
	                      _react2.default.createElement("div", {
	                        className: "Speakers_post",
	                        dangerouslySetInnerHTML: { __html: item.post }
	                      })
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h4",
	            { className: "ignite-ask-me-anything__heading", id: "IndustryLeaders", style: { fontSize: '20px' } },
	            "Session 1"
	          ),
	          _react2.default.createElement(
	            "p",
	            { "class": "ignite-ask-me-anything__date" },
	            "Panel discussion with recent hires on getting that investing job"
	          ),
	          _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	          _react2.default.createElement(
	            "div",
	            { className: "Our_Speakers container" },
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: "Speakers_img", style: { width: '65%' } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  this.Speaker1.map(function (item, i) {
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        className: "main_speaker_card col-md-3 col-sm-3 col-lg-3",
	                        key: i
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Scardd" },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "s_img",
	                            onClick: function onClick() {
	                              return _this3.togglePopUp(item);
	                            }
	                          },
	                          _react2.default.createElement("br", null),
	                          "      ",
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            "  ",
	                            _react2.default.createElement("img", {
	                              src: item.imgUrl,
	                              alt: item.name,
	                              className: "img-responsive",
	                              style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                            })
	                          )
	                        ),
	                        _react2.default.createElement("br", null),
	                        "    ",
	                        _react2.default.createElement("div", {
	                          className: "Speakers_name",
	                          dangerouslySetInnerHTML: { __html: item.name }
	                        }),
	                        _react2.default.createElement("div", {
	                          className: "Speakers_post",
	                          dangerouslySetInnerHTML: { __html: item.post }
	                        })
	                      )
	                    );
	                  })
	                )
	              ),
	              " "
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h4",
	            { className: "ignite-ask-me-anything__heading", id: "IndustryLeaders", style: { fontSize: '20px' } },
	            "Session 2"
	          ),
	          _react2.default.createElement(
	            "p",
	            { "class": "ignite-ask-me-anything__date" },
	            " Recruiters' insights on how to make a good CV"
	          ),
	          _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	          _react2.default.createElement(
	            "div",
	            { className: "Our_Speakers container" },
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: "Speakers_img", style: { width: '65%' } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  this.Speaker2.map(function (item, i) {
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        className: "main_speaker_card col-md-3 col-sm-3 col-lg-3",
	                        key: i
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Scardd" },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "s_img",
	                            onClick: function onClick() {
	                              return _this3.togglePopUp(item);
	                            }
	                          },
	                          _react2.default.createElement("br", null),
	                          "     ",
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            "  ",
	                            _react2.default.createElement("img", {
	                              src: item.imgUrl,
	                              alt: item.name,
	                              className: "img-responsive",
	                              style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                            })
	                          )
	                        ),
	                        _react2.default.createElement("br", null),
	                        "    ",
	                        _react2.default.createElement("div", {
	                          className: "Speakers_name",
	                          dangerouslySetInnerHTML: { __html: item.name }
	                        }),
	                        _react2.default.createElement("div", {
	                          className: "Speakers_post",
	                          dangerouslySetInnerHTML: { __html: item.post }
	                        })
	                      )
	                    );
	                  })
	                )
	              ),
	              " "
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h4",
	            { className: "ignite-ask-me-anything__heading", id: "IndustryLeaders", style: { fontSize: '20px' } },
	            "Session 3"
	          ),
	          _react2.default.createElement(
	            "p",
	            { "class": "ignite-ask-me-anything__date" },
	            "Mock interview panel"
	          ),
	          _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	          _react2.default.createElement(
	            "div",
	            { className: "Our_Speakers container" },
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: "Speakers_img", style: { width: '45%' } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  this.Speaker3.map(function (item, i) {
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        className: "main_speaker_card col-md-6 col-sm-6 col-lg-6",
	                        key: i
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Scardd" },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "s_img",
	                            onClick: function onClick() {
	                              return _this3.togglePopUp(item);
	                            }
	                          },
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            "  ",
	                            _react2.default.createElement("img", {
	                              src: item.imgUrl,
	                              alt: item.name,
	                              className: "img-responsive",
	                              style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                            })
	                          )
	                        ),
	                        _react2.default.createElement("br", null),
	                        "    ",
	                        _react2.default.createElement("div", {
	                          className: "Speakers_name",
	                          dangerouslySetInnerHTML: { __html: item.name }
	                        }),
	                        _react2.default.createElement("div", {
	                          className: "Speakers_post",
	                          dangerouslySetInnerHTML: { __html: item.post }
	                        })
	                      )
	                    );
	                  })
	                )
	              ),
	              " "
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return CareerBootcamp;
	}(_react.Component);
	
	CareerBootcamp.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = CareerBootcamp;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-careerbootcamp-index-js-dbe7464b18ca08b74665.js